import i18next from "i18next"

const isDirectionLtr = (language) => i18next.dir(language) === "ltr"

export default isDirectionLtr